// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import { app } from '../../app';
import { SmartTable } from '../../components/smart-table/smart-table.model';
import { SpAlert } from '../../components/sp-alert/sp-alert.model';
import { resolve } from '../../init/store';

app.factory('SharedEmailAccountModal', modal);

/** @ngInject */
function modal($uibModal) {

    return function (username, companyUserId) {

        return $uibModal.open({
            templateUrl: require('./shared-email-account.html'),
            controller,
            resolve: {
                userAccounts,
            },
        }).result;

        /** @ngInject */
        function controller(
            $rootScope,
            $scope,
            $state,
            $translate,
            $uibModalInstance,
            Alert,
            CompanyUser,
            ConfirmDeleteModal,
            UserAccounts,
            userAccounts
        ) {
            $scope.st = new SmartTable();
            $scope.cancel = () => $uibModalInstance.dismiss();
            $scope.step = "step1";
            $scope.username = username;
            $scope.companyUserId = companyUserId;
            const companyId = $state.params.companyId;
            
            $scope.isSendingRequest = false;
            
            function reload() {
                $scope.userAccounts = UserAccounts.getSharedEmailAccountsByUsername({
                    companyId : companyId,
                    username : username
                }, function() {
                        if($scope.userAccounts.length == 0){
                            $uibModalInstance.close();
                        }
                });
            }
            
            $scope.cancleSearch = function(){
                $scope.userIdentifier = null;
                $scope.successResult = null;
                $scope.showVerification = false;
                $scope.companyUser = null;
                $scope.message = null;
                $scope.newUserIdentifier = null;
            }
            
            $scope.unshare = function(account){
                ConfirmDeleteModal('groups_users.confirm_shared_email_account_delete')
                    .then(() => $scope.deleteConfirmed(account));
               
                
            }
            
            $scope.deleteConfirmed = function(account) {
                
                
                var param = {
                        companyId: companyId,
                        id: account.id
                }
                
                UserAccounts.deleteUserAccount(param, {}, function(success){
                    const key = 'groups_users.user_delete_success';
                    $scope.globalTopLevelMessage = new SpAlert('success', key);
                    reload();
                }, function(error){
                    $scope.globalTopLevelMessage = new SpAlert('danger', error.data.message);
                    
                });
            }

            
            $scope.share = function(saaspassId){
                if($scope.isSendingRequest){
                    return;
                }
                $scope.isSendingRequest = true;
                
                var param = {
                        companyId: companyId
                }
                var dataReq = {
                        username: username,
                        companyUser: $scope.companyUser
                }
                
                UserAccounts.createSharedUserAccount(param, dataReq, function(data){
                    $scope.groupsOfUser = UserAccounts.getGroupsOfAccount({
                        companyId : companyId,
                        id : data.id
                    });
                    $scope.userAccount = data;
                    $scope.username = data.username;
                    $scope.newAccount = data;
                    const key = 'groups_users.added_active_account_SHARED_EMAIL';
                    const variables = {saaspassId};
                    Alert('success', key, variables);
                    $uibModalInstance.close();
                }, function(error){
                    
                    $scope.globalTopLevelMessage = new SpAlert('danger', error.data.message);
                })
                
            }
            
           
            
            $scope.identifyUser = function() {
                $scope.message = null;
                    $scope.userIdentifier = $scope.newUserIdentifier;

                    if ($scope.userIdentifier == $scope.currentSaaspassId) {
                        $scope.successResult = false;
                        $scope.showVerification = false;

                        $scope.message = 'groups_users.user_is_the_same';
                    } else if ($scope.userIdentifier == $scope.currentEmailAddress) {
                        $scope.successResult = false;
                        $scope.showVerification = false;

                        $scope.message = 'groups_users.user_email_is_the_same';
                    } else {
                        CompanyUser.identifyCompanyUser({
                            companyId : companyId,
                            uid : encodeURIComponent($scope.userIdentifier)
                        }, function(data) {
                            if ((data.id && data.id == $scope.currentCompanyUserId) ||
                                    (data.saaspassUser && data.saaspassUser.id == $scope.currentSaaspassId)) {
                                $scope.successResult = false;
                                $scope.showVerification = false;

                                $scope.message = 'groups_users.user_is_the_same';
                            } else {
                                $scope.successResult = true;
                                $scope.showVerification = false;
                                $scope.companyUser = data;

                                $scope.message = 'groups_users.user_found';
                            }
                        }, function(response) {
                            $scope.successResult = false;
                            $scope.companyUser = null;

                            $scope.showVerification = $scope.enableVerification && !$scope.successResult
                                    && $rootScope.emailPattern.test($scope.userIdentifier);

                            if (response.status == 404) {
                                $scope.message = 'groups_users.user_not_found';
                            } else {
                                $scope.message = response.data.message;
                            }
                        });
                    }
            }
            $scope.cancleSearch();
            $scope.userAccounts = userAccounts;
        }

        /** @ngInject */
        function userAccounts(UserAccounts) {
            const companyId = resolve.companyId;
            return UserAccounts.getSharedEmailAccountsByUsername({companyId, username}).$promise;
        }
    }
}



// WEBPACK FOOTER //
// ./src/portal/modals/shared-email-account/shared-email-account.modal.js